
/**
 * This will do a deep equal on two objects.
 * @param {object} a
 * @param {object} b
 * @param {number} callCount should not be supplied
 * @return {boolean}
 */
function equals(a, b, callCount=0) {
    for (const property in a) {
        if (typeof a[property] === 'object') {
            if (!equals(a[property], b[property])) {
                return false
            }
        } else if (a[property] !== b[property]) {
            return false
        }
    }

    if (callCount === 0) {
        return equals(b, a, callCount+1)
    }

    return true
}

module.exports = {
    equals,
}

